import React from 'react'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'
import { PostConnectStepFrame } from '../PostConnectStepFrame'
import { OnboardingStepFinished } from '../../Onboarding/OnboardingStepFinished/OnboardingStepFinished'
import { getCustomCompletedLink, POST_CONNECT_COPIES } from '../../copies/onboardingCopies'
import { Capability } from '../../../../models/Onboarding'

export interface ContactsSuccessStepProps {
  serviceId: IntegrationServiceId
  onContinue: () => void
  onBack?: () => void
}

export const ContactsSuccessStep: React.FC<ContactsSuccessStepProps> = ({ serviceId, onContinue, onBack }) => {
  const displayName = getIntegrationDisplayName(serviceId)

  const customLink = getCustomCompletedLink([serviceId], Capability.CONTACT_SOURCE)

  return (
    <PostConnectStepFrame onAdvance={onContinue} onBack={onBack} nextLabel='Done'>
      <OnboardingStepFinished
        title={`${displayName} contacts set up successfully`}
        bullets={POST_CONNECT_COPIES['contact-success'].bullets}
        links={customLink ? [customLink] : undefined}
      />
    </PostConnectStepFrame>
  )
}
